import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "components";
import { useForm } from "react-hook-form";
import { useAppSelector } from "store/hooks";
import { schema } from './schema';

export const SocialItentHeader = ({ handleOpen }: { handleOpen: () => void }) => {
    const { exportOpen, filterOpen } = useAppSelector((state) => state.ui);

    const form = useForm({
        resolver: zodResolver(schema)
    })

    return (
        <div className='w-full flex justify-end'>
            <Button size='sm' iconName='plus' className='w-full md:w-fit' action='button' onClick={handleOpen}>Add Keywords</Button>
        </div>
    )
}
